/* eslint-disable react-refresh/only-export-components */
import Logo from "@/assets/icons/logo.svg?react";
import { Wizard } from "@/components";
import { Box, CssBaseline, Link, Typography } from "@mui/material";
import { cloneElement, FC, isValidElement, ReactNode } from "react";
import { LoginPageContextProvider } from "../../context";
import { LoginStep } from "../login-step";
import { SetPasswordStep } from "../set-password-step";

export enum WizardName {
  LOGIN = "LOGIN",
  SET_PASSWORD = "SET_PASSWORD",
}

const wizardSteps: Array<{
  name: string;
  component: ReactNode;
}> = [
  {
    name: WizardName.LOGIN,
    component: (
      <LoginStep
        stepName={WizardName.LOGIN}
        title="Login to your account!"
        description="Enter your credentials to access admin features"
      />
    ),
  },
  {
    name: WizardName.SET_PASSWORD,
    component: (
      <SetPasswordStep
        stepName={WizardName.SET_PASSWORD}
        title="Change Your Password"
        description="For your security, we require you to change your password upon first login."
      />
    ),
  },
];

const LoginPage: FC = () => {
  return (
    <LoginPageContextProvider>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          p: 2,
          pt: 20,
          alignItems: "center",
          margin: "0 auto",
          maxWidth: "500px",
        }}
      >
        <CssBaseline />
        <Logo width={"100%"} />

        <Wizard>
          {wizardSteps.map(({ name, component }) =>
            isValidElement(component)
              ? cloneElement(component, { key: name })
              : null
          )}
        </Wizard>

        <Box
          sx={{
            position: "absolute",
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            bottom: 10,
          }}
        >
          <Typography variant="body2" align="center">
            © 2024 Société.&nbsp;|&nbsp;
            <Link
              href="https://sunset.app/privacy-policy"
              color="inherit"
              underline="hover"
              target="_blank"
            >
              Privacy Policy
            </Link>{" "}
            &nbsp;|&nbsp;
            <Link
              href="mailto:info@sunset.app"
              underline="hover"
              target="_blank"
            >
              info@sunset.app
            </Link>
          </Typography>
        </Box>
      </Box>
    </LoginPageContextProvider>
  );
};

export { LoginPage };
